var m=(e=>(e.none="",e.small="small",e.medium="medium",e.large="large",e.custom="custom",e))(m||{});export{m as a};
//# sourceMappingURL=ninox-components-H2F3OART.js.map